class TutorialManager {
   constructor() {
    this.tutorialReplayModal = new Modal('modal-replay-tutorial', 'modal-trigger-replay-tutorial');
    this.tutorialElements = document.querySelectorAll('.has-toturial');
    this.tutorialOverlay = document.querySelector('.toturial-overlay');
    this.tutorialOverlayContent = document.querySelector('.toturial-overlay__content');
    this.tutorialOverlayClose = document.querySelectorAll('.toturial-overlay__close');
    this.replayToturialsButton = document.querySelector('.replay-toturial');
    this.toturial = null;

    if (document.cookie.includes('tut-shown') || document.querySelector('.product-preview').classList.contains('has-toturial-april')) {
        return;
    }

    if (this.tutorialElements && this.tutorialOverlay && this.tutorialOverlayClose) {
      this.handleToturials();
      document.cookie = 'tut-shown';
    }
  }


  handleToturials() {
    const toggleOverlay = () => {
      document.body.classList.remove('overflow-hidden'); 
      document.querySelector('.product-preview').classList.add('is-sticky');
      this.tutorialOverlay.classList.remove('show');
      this.tutorialElements.forEach((element) => {
        const toturial = element.querySelector('.toturial');
        if (toturial) {
          toturial.remove();
        }
      });
    };

    document.body.classList.add('overflow-hidden'); 
    document.querySelector('.product-preview').classList.remove('is-sticky');
    this.tutorialOverlay.classList.add('show');
    this.tutorialOverlayClose.forEach((overlayClose) => {
      overlayClose.addEventListener('click', ()=>{
        toggleOverlay();
        document.body.classList.remove('overflow-hidden');
        document.querySelector('.product-preview').classList.add('is-sticky');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          toggleOverlay();
          document.querySelector('.product-preview').classList.add('is-sticky');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    });

    this.tutorialOverlay.addEventListener('click', (e) => {
      if (!this.tutorialOverlayContent.contains(e.target)) {
        toggleOverlay();
      }
    });

    this.tutorialElements.forEach((element) => {
      const toturialText = element.getAttribute('data-toturial');
      const toturial = document.createElement('div');
      toturial.classList.add('toturial');
      toturial.textContent = toturialText;
      element.appendChild(toturial);
    });
  }

  replayToturials() {
    this.tutorialReplayModal.hide();
    this.handleToturials();
  }
}

const tutorialManager = new TutorialManager();
if (tutorialManager.replayToturialsButton) {
  tutorialManager.replayToturialsButton.addEventListener('click', () => {
    
    window.scrollTo({ top: 0, behavior: 'smooth' });
    tutorialManager.replayToturials();
  });
}
